<template>
    <v-app>
        <v-main>
            <v-container>
                <v-layout justify-center>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-card>
                            <v-card-title class="pb-5">
                                <!--                                    v-if="$can('transaction_create')"-->
                                <v-btn to="/category" rounded color="#A5668B" class="text-white">
                                    <v-icon>mdi-backspace-reverse-outline</v-icon>
                                    بازگشت
                                </v-btn>
                                <v-spacer/>
                                {{ $route.meta.title }}
                                <v-spacer/>
                                <v-btn @click="updateCategory" color="#50858B" rounded
                                       class="text-white">
                                    <v-icon>mdi-refresh</v-icon>
                                    ذخیره
                                </v-btn>
                                <!--                            <v-card elevation="2" outlined>-->
                            </v-card-title>


                            <v-card-text>
                                <v-row>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-text-field
                                            :rules="rules.name"
                                            @keypress.enter="updateCategory"
                                            v-model="name"
                                            :error-messages="errors.name"
                                            label="اسم"
                                            autofocus
                                            required
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-text-field
                                            v-model="image"
                                            :error-messages="errors.image"
                                            label="کد ایکون"
                                            required
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-select
                                            v-model="special"
                                            :rules="rules.special"
                                            :items="specials"
                                            :error-messages="errors.service"
                                            item-text="name"
                                            item-value="value"
                                            label="منو سربرگ"
                                            outlined
                                            dense
                                            return-object
                                        ></v-select>
                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-select
                                            v-model="service"
                                            :rules="rules.service"
                                            :items="services"
                                            :error-messages="errors.service"
                                            item-text="nameLand"
                                            item-value="id"
                                            label="انتخاب سرویس"
                                            outlined
                                            dense
                                            return-object
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-select
                                            v-model="status"
                                            :rules="rules.type"
                                            :items="types"
                                            item-text="name"
                                            item-value="value"
                                            label="وضعیت نمایش"
                                            outlined
                                            dense
                                            return-object
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-text-field
                                            v-model="link"
                                            label="پیوند"
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                                        <v-text-field
                                            v-model="sortOrder"
                                            :error-messages="errors.sort_order"
                                            label="اولویت نمایش"
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                                        <v-select
                                            v-model="parentId"
                                            :items="parents"
                                            item-text="name"
                                            item-value="id"
                                            label="دسته بندی والد"
                                            outlined
                                            dense
                                            return-object
                                        ></v-select>
                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-container fluid>
                                        <v-textarea
                                            v-model="description"
                                            autocomplete="email"
                                            :error-messages="errors.description"
                                            label="توضیحات"
                                            outlined
                                            dense
                                        ></v-textarea>
                                    </v-container>

                                </v-row>

                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";

export default {
    props: ['id'],
    data() {
        return {
            service: null,
            status: null,
            parentId: null,
            services: [],
            query: {sort: 'id', order: 'desc', limit: 100, s: ''},
            rules: {
                name: [val => (val || '').length > 0 || 'فیلد عنوان الزامی می باشد'],
                services: [val => !!val || 'فیلد سرویس الزامی می باشد'],
                status: [val => !!val || 'فیلد وضعیت الزامی می باشد'],
            },
            specials: [
                {name: 'بله', value: 1},
                {name: 'خیر', value: 0},
            ],
            special: null,
            types: [
                {name: 'نمایش', value: 1},
                {name: 'عدم نمایش', value: 0},
            ],
            name: '',
            description: '',
            image: null,
            link: '',
            sortOrder: '',
            errors: [],
            parents: [],
        }
    },
    created() {
        this.getCategory()
        this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}]);

    },


    mounted() {
        this.services = this.getService().data
        this.parents = this.getParents()
    },

    methods: {
        getParents() {
            this.requestApiGet(`category/getParents`
            ).then(({data}) => {
                this.parents = data
            }).catch(e => {
                console.log(e)
            })
        },
        updateCategory() {
            this.requestApiPost(`categories/${this.id}`, {
                name: this.name,
                description: this.description,
                image: this.image,
                slug: this.link,
                sort_order: this.sortOrder,
                parent_id: this.parentId.id,
                service_id: this.service.id,
                status: this.status.value,
                special: this.special.value,
                _method: 'PUT',
            }).then((response) => {
                this.goto('category')
                this.$toast('با موفقیت به روز رسانی شد');
                return false;
            }).catch(({response}) => {
                this.errors = response
            })

        },

        getCategory() {
            this.requestApiGet(`categories/${this.id}`
            ).then(({data}) => {
                this.service = data.service_id
                this.name = data.name
                this.description = data.description
                this.parentId = data.parent_id
                this.status = data.status
                this.special = data.special
                this.sortOrder = data.sort_order
                this.link = data.slug
                this.image = data.image
            }).catch(e => {
                console.log(e)
            })
        },

    }

}
</script>
